import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { replayDrawing } from "./lib/state/engine-bridge.svelte";

import {
	art,
	copyShareLink,
	debugMode,
	randomize,
	randomizeSettings,
	shareHash
} from "./lib/state/params.svelte";

import CanvasHost from "./lib/ui/CanvasHost.svelte";
import ControlPanel from "./lib/ui/ControlPanel.svelte";
import Fallback from "./lib/ui/Fallback.svelte";
import FpsMeter from "./lib/ui/FpsMeter.svelte";
import Hint from "./lib/ui/Hint.svelte";
import Toast, { showToast } from "./lib/ui/Toast.svelte";
import TopBar from "./lib/ui/TopBar.svelte";
import { attachShortcuts } from "./lib/util/keyboard";

var root = $.from_html(`<!> <div><!> <!></div>`, 1);
var root_1 = $.from_html(`<!> <!> <!> <!>`, 1);

export default function App($$anchor, $$props) {
	$.push($$props, true);

	const webgl2 = !!document.createElement("canvas").getContext("webgl2");

	// URL sync: history.replaceState debounced 500 ms after the last state
	// change (the Share handler flushes synchronously via copyShareLink).
	$.user_effect(() => {
		const hash = shareHash(); // reads params/seed/presetId → tracked
		const timer = setTimeout(() => history.replaceState(null, "", hash), 500);

		return () => clearTimeout(timer);
	});

	$.user_effect(() => attachShortcuts({
		" ": () => randomizeSettings(),
		p: () => {
			if (art.settled) replayDrawing(); else art.paused = !art.paused;
		},
		r: () => randomize(),
		s: () => randomizeSettings(),
		h: () => art.uiHidden = !art.uiHidden,
		e: () => {
			if (art.exporting) return;

			if (art.exportMenuOpen) {
				art.exportMenuOpen = false;
			} else {
				art.uiHidden = false;
				art.panelOpen = true;
				art.exportMenuOpen = true;
			}
		},

		c: () => {
			void copyShareLink().then((ok) => showToast(ok
				? "Link copied"
				: "Copy failed — the link is in the address bar"));
		},

		escape: () => {
			if (art.exportMenuOpen) art.exportMenuOpen = false; else if (art.panelOpen) art.panelOpen = false;
		}
	}));

	var fragment = root_1();
	var node = $.first_child(fragment);

	{
		var consequent = ($$anchor) => {
			var fragment_1 = root();
			var node_1 = $.first_child(fragment_1);

			CanvasHost(node_1, {});

			var div = $.sibling(node_1, 2);
			let classes;
			var node_2 = $.child(div);

			TopBar(node_2, {});

			var node_3 = $.sibling(node_2, 2);

			ControlPanel(node_3, {});
			$.reset(div);
			$.template_effect(() => classes = $.set_class(div, 1, 'chrome svelte-2dzj0e7yj7i7w', null, classes, { hide: art.uiHidden }));
			$.append($$anchor, fragment_1);
		};

		var alternate = ($$anchor) => {
			Fallback($$anchor, {});
		};

		$.if(node, ($$render) => {
			if (webgl2) $$render(consequent); else $$render(alternate, -1);
		});
	}

	var node_4 = $.sibling(node, 2);

	Toast(node_4, {});

	var node_5 = $.sibling(node_4, 2);

	{
		var consequent_1 = ($$anchor) => {
			Hint($$anchor, {});
		};

		$.if(node_5, ($$render) => {
			if (webgl2) $$render(consequent_1);
		});
	}

	var node_6 = $.sibling(node_5, 2);

	{
		var consequent_2 = ($$anchor) => {
			FpsMeter($$anchor, {});
		};

		$.if(node_6, ($$render) => {
			if (debugMode) $$render(consequent_2);
		});
	}

	$.append($$anchor, fragment);
	$.pop();
}
import "bun-svelte:App.svelte-1y7n8tas25cy1-style.css";